import { Component, input, signal } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'lepi-image',
  standalone: true,
  imports: [NgOptimizedImage],
  templateUrl: './image.component.html',
  styleUrl: './image.component.css',
})
export class Image {
  src = input.required<string>();

  loaded = signal<boolean>(false);
  error = signal<boolean>(false);

  onLoad() {
    this.loaded.set(true);
  }

  onError() {
    this.error.set(true);
  }
}
